export enum PaymentTiming {
  AFTER_TRIP_PAYMENT = 'AFTER_TRIP_PAYMENT',
  BEFORE_TRIP_PAYMENT = 'BEFORE_TRIP_PAYMENT',
}
